import { CellKeyFieldsPartial } from '../../typings/common';
import { FeedFilterPricesInfo, FeedFilterRateType } from '../../typings/feedFilters';

export const UPDATE_FEED_FILTER_RATE_CELL = 'UPDATE_FEED_FILTER_RATE_CELL';
export type UPDATE_FEED_FILTER_RATE_CELL = typeof UPDATE_FEED_FILTER_RATE_CELL;

export interface UpdateFeedFilterRateCellAction {
    type: UPDATE_FEED_FILTER_RATE_CELL;
    cellKeyPartial: CellKeyFieldsPartial;
    rateType: FeedFilterRateType;
}

export function updateFeedFilterRateCell(
    filterId: string,
    column: string,
    rateType: FeedFilterRateType
): UpdateFeedFilterRateCellAction {
    return {
        type: UPDATE_FEED_FILTER_RATE_CELL,
        cellKeyPartial: {
            id: filterId,
            column
        },
        rateType
    };
}

export const UPDATE_FEED_FILTER_PRIORITY_CELL = 'UPDATE_FEED_FILTER_PRIORITY_CELL';
export type UPDATE_FEED_FILTER_PRIORITY_CELL = typeof UPDATE_FEED_FILTER_PRIORITY_CELL;

export interface UpdateFeedFilterPriorityCellAction {
    type: UPDATE_FEED_FILTER_PRIORITY_CELL;
    cellKeyPartial: CellKeyFieldsPartial;
}

export function updateFeedFilterPriorityCell(filterId: string, column: string): UpdateFeedFilterPriorityCellAction {
    return {
        type: UPDATE_FEED_FILTER_PRIORITY_CELL,
        cellKeyPartial: {
            id: filterId,
            column
        }
    };
}

export const UPDATE_FEED_FILTER_CELL_RESULT = 'UPDATE_FEED_FILTER_CELL_RESULT';
export type UPDATE_FEED_FILTER_CELL_RESULT = typeof UPDATE_FEED_FILTER_CELL_RESULT;

export interface UpdateFeedFilterCellResultAction {
    type: UPDATE_FEED_FILTER_CELL_RESULT;
    feedFilter: FeedFilterPricesInfo;
}

export function updateFeedFilterCellResult(feedFilter: FeedFilterPricesInfo): UpdateFeedFilterCellResultAction {
    return {
        type: UPDATE_FEED_FILTER_CELL_RESULT,
        feedFilter
    };
}

export const TOGGLE_FEED_FILTER_PRIORITY_MODAL = 'TOGGLE_FEED_FILTER_PRIORITY_MODAL';
export type TOGGLE_FEED_FILTER_PRIORITY_MODAL = typeof TOGGLE_FEED_FILTER_PRIORITY_MODAL;

export interface ToggleFeedFilterPriorityModalAction {
    type: TOGGLE_FEED_FILTER_PRIORITY_MODAL;
}

export function toggleFeedFilterPriorityModal(): ToggleFeedFilterPriorityModalAction {
    return {
        type: TOGGLE_FEED_FILTER_PRIORITY_MODAL
    };
}

export const TOGGLE_FEED_FILTER_RATE_MODAL = 'TOGGLE_FEED_FILTER_RATE_MODAL';
export type TOGGLE_FEED_FILTER_RATE_MODAL = typeof TOGGLE_FEED_FILTER_RATE_MODAL;

export interface ToggleFeedFilterRateModalAction {
    type: TOGGLE_FEED_FILTER_RATE_MODAL;
}

export function toggleFeedFilterRateModal(): ToggleFeedFilterRateModalAction {
    return {
        type: TOGGLE_FEED_FILTER_RATE_MODAL
    };
}

export type FeedFiltersGridAction =
    | ToggleFeedFilterRateModalAction
    | ToggleFeedFilterPriorityModalAction
    | UpdateFeedFilterRateCellAction
    | UpdateFeedFilterPriorityCellAction
    | UpdateFeedFilterCellResultAction;
